export const LIST_SCOOTER_ELECTRICAL = "LIST_SCOOTER_ELECTRICAL";
export const LIST_BICYCLE_ELECTRICAL = "LIST_BICYCLE_ELECTRICAL";
export const LOADING_ALL_ELECTRICAL = "LOADING_ALL_ELECTRICAL";
export const SELECTED_ITEM_ELECTRICAL = "SELECTED_ITEM_ELECTRICAL";
export const LIST_FEATURED_ELECTRICAL="LIST_FEATURED_ELECTRICAL";